import React, { Ref } from "react";
import classNames from "classnames";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import { Image } from "antd-mobile";
import styles from "./index.module.less";
import { game_question_answer, game_success, game_warn } from "~src/assets/images/answerGame";
import { AnswerQuestionRef, MaskConfig, OptionType, QuestionCartType, QuestionType, Types } from "~src/service/answer/answer";
import Circle from "./Circle";
import { postFriendSubmit, submitBegin } from "~src/service/answer";
import MaskContent from "./MaskContent";
import { useWXPath } from "~src/hooks/useWXPath";


type nameString = {
  [K in Types]: string
};

interface AnswerQuestionProps {
  disableds?: boolean
  index: number
  maxIndex: number
  item: QuestionType
  type?: QuestionCartType
  inviter: number
  onClickOption: (row: OptionType, id: number, assist?: number) => void
  onCountdown: () => void
}

const AnswerQuestion = ({
  type = "self",
  disableds = true,
  item = {} as QuestionType,
  inviter,
  index,
  maxIndex,
  onClickOption,
  onCountdown
}: AnswerQuestionProps, ref: Ref<AnswerQuestionRef>) => {
  const answer = useMemo(() => {
    return ["A", "B", "C", "D", "E", "F","G"]
  }, [])
  const [items, setItems] = useState<QuestionType>({} as QuestionType)
  const QuestionTypeName: nameString = useMemo(() => ({ 1: '选择题', 2: '判断题' }), [])
  const [disabled, setDisabled] = useState<boolean>(disableds) // 可选状态
  const [AnswerStatus, setAnswerStatus] = useState<boolean>() // 答题状态
  const [AnswerResult, setAnswerResult] = useState(false) // 答题结果
  const [optionIndex, setOptionIndex] = useState<number>() // 答题index
  const wxPath = useWXPath()
  const [maskcof, setMaskcof] = useState<MaskConfig>({} as MaskConfig)
  const restarRef = useRef<any>()
  const onFriendsOpenMask = useCallback(() => {
    wxPath("redirectTo", "/pages/answer_game/index")
    setMaskcof((prev) => ({ ...prev, visible: false }))
  }, [wxPath])

  const getSubmitType = async (row: OptionType, index: number, type: QuestionCartType) => {
    if (type === "self") {
      const { right, ans = [],assist } = await submitBegin({ id: items.id, option: [row] })
      const item = items
      try {
        const ansIndex = ans[0]
        item.option[index] = { ...row, value: right }
        item.option[ansIndex] = { ...item.option[ansIndex], value: 1 }
        items.answer = ansIndex
        setItems(() => item)
      } catch (error) {
        console.log(error, "选择时出错")
      }
      setAnswerResult(right ? true : false)
      return {row:item.option[index] , assist}
    }
    if (type === "friends") {
      const { status, right, ans = [] } = await postFriendSubmit({
        questionId: items.id,
        option: [row],
        inviter: inviter
      })
      setAnswerResult(right ? true : false)
      if (status === 10004) {
        setMaskcof({
          visible: true,
          topIcon: "wait_fail",
          title: "助力时间已过",
          desc: <>
            <div>和绿喵一起涨知识 </div>
            <div>兑换惊喜礼品吧</div>
          </>,
          okText: "我也要答题",
          onOk: onFriendsOpenMask,
        })
        return
      }
      const item = items
      const ansIndex = ans[0]
      item.option[index] = { ...row, value: right }
      items.answer = ansIndex
      return {row:item.option[index]}
    }
  }
  const onAnswer = useCallback(async (row: OptionType, index: number) => {
   const data = await getSubmitType(row, index, type)
    const itemRow = await items.option[index]
    if (!disabled) return
    if (itemRow.value) {
      setAnswerStatus(true)
    }
    setOptionIndex(index)
    onClickOption(itemRow, items.id, data?.assist)
    setDisabled(false)
    if (restarRef.current) {
      restarRef.current.stopCountdown()
    }
  }, [disabled, inviter, items, onClickOption, onFriendsOpenMask, type])
  useEffect(() => {
    setDisabled(disableds)
  }, [disableds])
  useEffect(() => {
    setItems(item)
  }, [item])
  useEffect(() => {
    setDisabled(true)
    setAnswerStatus(false)
    setAnswerResult(false)
    setOptionIndex(undefined)
    if (restarRef.current) {
      restarRef.current.restartCountdown(15000)
    }
  }, [index])

  const onAnswerStatus = () => {
    console.log("放弃回答")
    setAnswerStatus(true)
  }
  const onAbandonAnswering = () => { }
  const onClickCountdown = () => {
    setDisabled(false)
    onCountdown && onCountdown()
  }
  const setCountText = (num: number) => {
    if (restarRef.current) {
      restarRef.current.setCountText(num)
    }
  }
  const restartCountdown = (timer?: number) => {
    if (restarRef.current) {
      restarRef.current.restartCountdown(timer)
    }
  }
  useImperativeHandle(ref, () => ({
    onAnswerStatus,
    setCountText,
    restartCountdown
  }))
  return <div className={styles["question-con"]}>
    <div className={styles["question-content"]}>
      <Circle
        ref={restarRef}
        onClickCountdown={onClickCountdown} />
      < div className={styles["question-dec"]}>
        <div className={styles["question-dec-name"]}>{QuestionTypeName[items.type]}</div>
        <div className={styles["question-dec-wall"]}>|</div>
        <div>{index + 1}/{maxIndex}</div>
      </div>
      <div className={styles["question-title"]}>{items.stem}</div>
      <div className={styles["question-option"]}>
        {
          items.option?.map((option, index) => {
            return <div key={option.code}
              className={
                classNames(
                  styles["question-option-item"],
                  optionIndex === index ? (AnswerResult ? styles["question-option-success"] : styles["question-option-warn"]) : '',
                  optionIndex && optionIndex !== index ? ((!AnswerResult && option.value === 1) && styles["question-option-success"]) : ""
                )
              }
              onClick={onAnswer.bind(null, option, index)}>
              <span className={styles["question-option-item-txt"]}>
                {option.code}.{option.content}
              </span>
              {
                !!AnswerStatus && (optionIndex === index || option.value === 1) && <Image className={styles["question-option-item-img"]} src={option.value === 1 ? game_success : game_warn}></Image>
              }
            </div>
          })
        }
      </div>
    </div>
    {
      (AnswerStatus) && <div>
        <Image className={styles.game_question_answer} src={game_question_answer}></Image>
        <div className={styles["question-ans"]}>
          <div className={styles["question-ans-title"]}> 【答案： {answer[items.answer]}】 </div>
          <div className={styles["question-ans-detail"]}>{items.description}</div>
        </div>
      </div>
    }
    <MaskContent
      title={maskcof.title}
      desc={maskcof.desc}
      okText={maskcof.okText}
      cancelText={maskcof.cancelText}
      onCancel={maskcof.onCancel}
      visible={maskcof.visible}
      onMaskClick={() => void 0}
      topIcon={maskcof.topIcon}
      onOk={maskcof.onOk}
    />
  </div >;
}
export default forwardRef<AnswerQuestionRef, AnswerQuestionProps>(AnswerQuestion)